<template>
  <div id="app" v-show="!loading">
    <img src="./assets/happy-store.png" class="logo" alt="happy store" />
    <div class="hst-background"></div>
    <template v-if="!show">
      <wallet ref="wallet" v-show="!loadingData"></wallet>
      <div class="wallet" v-if="!myAddress">
        <h4>选择钱包进行连接</h4>
        <p @click="linkMetaMask">
          <svg t="1577779690525" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1662" width="24" height="24"><path d="M572.224 361.19466667l-120.832 0.18773333-47.14666667-113.8688z" fill="#F6851B" p-id="1663"></path><path d="M404.24533333 247.5136l216.7488-0.45226667-48.77013333 114.13333334z" fill="#F6851B" p-id="1664"></path><path d="M451.392 361.3824L147.26826667 132.64213333l256.97706666 114.87146667z" fill="#E4761B" p-id="1665"></path><path d="M876.79786667 130.70933333l-304.576 230.48533334 48.77226666-114.13333334z" fill="#E2761B" p-id="1666"></path><path d="M270.64106667 458.77973333l-137.8048-35.89973333L125.44 390.74133333zM137.5488 461.48906667l-4.71466667-38.60906667 137.80693334 35.89973333zM156.82773333 517.2544l113.81333334-58.47466667 59.17866666 10.51093334z" fill="#763D16" p-id="1667"></path><path d="M137.5488 461.48906667l133.09226667-2.70933334-113.81333334 58.47466667zM754.80106667 458.26986667l145.38666666-68.60373334-7.45813333 32.27733334zM887.9488 460.70613333l-133.14773333-2.43626666 137.92853333-36.32426667zM868.55466667 516.70613333l-173.71733334-47.78026666 59.96373334-10.656z" fill="#763D16" p-id="1668"></path><path d="M887.9488 460.70613333l-19.39413333 56-113.7536-58.43626666zM276.50773333 284.01066667l-5.86666666 174.76906666L125.44 390.74133333zM329.82186667 469.29066667l-59.1808-10.51093334 5.86666666-174.76906666z" fill="#763D16" p-id="1669"></path><path d="M333.26933333 824.46933333l45.16266667-23.89973333 7.89973333-1.86026667zM639.24053333 798.8608l6.97386667 1.87093333 44.05333333 23.99573334z" fill="#E2761B" p-id="1670"></path><path d="M900.18773333 389.66613333l-145.38666666 68.60373334-7.04-175.15946667z" fill="#763D16" p-id="1671"></path><path d="M747.76106667 283.1104l7.04 175.15946667-59.96586667 10.656z" fill="#763D16" p-id="1672"></path><path d="M333.26933333 824.46933333l-193.26506666 71.392L92.65066667 702.528z" fill="#E4761B" p-id="1673"></path><path d="M107.49013333 402.36373333l17.952-11.6224 7.39413334 32.13866667z" fill="#763D16" p-id="1674"></path><path d="M933.73226667 702.63893333l-47.40266667 194.02666667-196.06186667-71.936z" fill="#E4761B" p-id="1675"></path><path d="M276.50773333 284.01066667l174.88426667 77.37173333-121.57013333 107.90826667zM137.5488 461.48906667L112.46933333 436.992l20.3648-14.11413333zM694.8352 468.92586667L572.224 361.19466667l175.53706667-78.0864zM918.1568 401.2864l-25.4272 20.6592 7.45813333-32.27733333zM125.44 390.74133333l-22.35733333-134.1952 173.42506666 27.46453334zM156.82773333 517.2544l-35.9424-45.024 16.66133334-10.74133333z" fill="#763D16" p-id="1676"></path><path d="M887.9488 460.70613333l4.7808-38.76266666 20.37973333 14.12053333zM747.76106667 283.1104l174.33813333-28.2368-21.91146667 134.79253333z" fill="#763D16" p-id="1677"></path><path d="M275.75253333 529.63413333L92.65066667 702.52586667l64.17493333-185.27146667z" fill="#F6851B" p-id="1678"></path><path d="M868.55466667 516.70613333l19.392-56 16.6784 10.74773334z" fill="#763D16" p-id="1679"></path><path d="M246.9248 680.10453333l-154.272 22.42133334 183.09973333-172.89173334z" fill="#F6851B" p-id="1680"></path><path d="M92.6528 702.528l154.272-22.42346667 86.34666667 144.36266667z" fill="#E4761B" p-id="1681"></path><path d="M747.30453333 529.2992l121.25013334-12.59306667 65.1776 185.9328zM747.30453333 529.2992l186.42773334 173.33973333-157.57653334-22.5216z" fill="#F6851B" p-id="1682"></path><path d="M690.26773333 824.72746667l85.888-144.61013334 157.57653334 22.5216z" fill="#E4761B" p-id="1683"></path><path d="M156.82773333 517.2544l172.992-47.96373333-54.0672 60.34346666zM868.55466667 516.70613333l-121.25013334 12.59306667-52.46933333-60.37333333z" fill="#F6851B" p-id="1684"></path><path d="M329.82186667 469.29066667l121.57013333-107.90826667 9.1392 169.20746667zM460.5312 530.58986667l-184.77866667-0.95573334 54.06933334-60.34346666zM694.8352 468.92586667l52.46933333 60.37333333-186.00746666 1.22026667zM561.29706667 530.51733333l10.92693333-169.32266666 122.6112 107.7312z" fill="#E4761B" p-id="1685"></path><path d="M147.26826667 132.64213333L451.392 361.3824l-174.88426667-77.37173333zM276.50773333 284.01066667l-173.42293333-27.46453334 44.18133333-123.904zM876.79786667 130.70933333l45.30133333 124.16426667-174.33813333 28.2368zM747.76106667 283.1104l-175.53706667 78.0864L876.79786667 130.70933333z" fill="#763D16" p-id="1686"></path><path d="M451.392 361.3824l120.832-0.1856-10.92693333 169.32266667z" fill="#F6851B" p-id="1687"></path><path d="M561.29706667 530.51733333l-100.76586667 0.07253334-9.1392-169.20746667z" fill="#F6851B" p-id="1688"></path><path d="M333.26933333 824.46933333l-86.34453333-144.3648 103.7504-4.9536zM690.26773333 824.72746667l-18.93973333-149.57653334 104.82773333 4.9664zM349.17546667 600.82133333l-73.42293334-71.18933333 184.77866667 0.96z" fill="#CD6116" p-id="1689"></path><path d="M275.75253333 529.63413333l74.92266667 145.5168-103.7504 4.9536z" fill="#F6851B" p-id="1690"></path><path d="M275.75253333 529.63413333l73.42293334 71.18933334 1.49973333 74.32746666z" fill="#E4751F" p-id="1691"></path><path d="M561.29706667 530.51733333l186.00533333-1.21813333-74.21866667 71.4048z" fill="#CD6116" p-id="1692"></path><path d="M776.15573333 680.11733333l-104.82773333-4.9664L747.30666667 529.30133333z" fill="#F6851B" p-id="1693"></path><path d="M747.30453333 529.2992l-75.97653333 145.85173333 1.75573333-74.44693333z" fill="#E4751F" p-id="1694"></path><path d="M369.67466667 845.5488l-36.4032-21.0816 104.52266666 7.49226667zM580.97066667 832.06826667l109.29706666-7.33866667-37.54453333 21.056z" fill="#C0AD9E" p-id="1695"></path><path d="M460.5312 530.58986667l-44.83413333 39.21493333-66.5216 31.01866667z" fill="#CD6116" p-id="1696"></path><path d="M436.69546667 790.58346667l1.09866666 41.376-104.52266666-7.49226667z" fill="#D7C1B3" p-id="1697"></path><path d="M673.08373333 600.704l-66.77333333-30.99733333-45.01333333-39.18933334z" fill="#CD6116" p-id="1698"></path><path d="M446.03733333 713.14773333l-112.768 111.31946667 17.408-149.31626667z" fill="#E4761B" p-id="1699"></path><path d="M333.26933333 824.46933333l112.768-111.3216-9.34186666 77.43573334zM581.1712 790.66453333l109.09653333 34.06293334-109.29493333 7.3408z" fill="#D7C1B3" p-id="1700"></path><path d="M571.71413333 713.1712l99.61386667-38.02026667 18.93973333 149.57653334z" fill="#E4761B" p-id="1701"></path><path d="M690.26773333 824.72746667l-109.09653333-34.06293334-9.45706667-77.49333333z" fill="#D7C1B3" p-id="1702"></path><path d="M350.67733333 675.15093333l-1.50186666-74.3296 93.5104 22.62826667z" fill="#F6851B" p-id="1703"></path><path d="M442.68586667 623.4496l-93.5104-22.62826667 66.5216-31.01653333z" fill="#233447" p-id="1704"></path><path d="M671.328 675.15093333l-92.50133333-51.73333333 94.25706666-22.7136z" fill="#F6851B" p-id="1705"></path><path d="M578.82666667 623.41546667l27.48586666-53.7088 66.7712 30.99733333z" fill="#233447" p-id="1706"></path><path d="M415.69706667 569.8048l44.83413333-39.21493333-17.84533333 92.85973333zM606.31253333 569.70666667l-27.48586666 53.7088-17.5296-92.896z" fill="#CD6116" p-id="1707"></path><path d="M464.1536 583.94666667l-3.6224-53.35466667 100.76586667-0.07253333z" fill="#F6851B" p-id="1708"></path><path d="M442.68586667 623.4496l17.84533333-92.85973333 3.6224 53.3568z" fill="#E4751F" p-id="1709"></path><path d="M561.29706667 530.51733333l-4.3328 53.3888-92.81066667 0.04266667z" fill="#F6851B" p-id="1710"></path><path d="M578.82666667 623.41546667l-21.8624-39.50933334 4.3328-53.38666666z" fill="#E2761B" p-id="1711"></path><path d="M437.79413333 831.95733333l6.09493334 31.36853334-74.2144-17.77706667zM652.7232 845.7856l-78.07146667 17.66186667 6.32106667-31.3792z" fill="#C0AD9E" p-id="1712"></path><path d="M446.03733333 713.14773333l-95.36-37.99466666 92.00853334-51.70346667zM578.82666667 623.41546667l92.50133333 51.73546666-99.61386667 38.02026667z" fill="#F6851B" p-id="1713"></path><path d="M464.1536 583.94666667l-1.8944 117.9136-19.57333333-78.41066667z" fill="#E4751F" p-id="1714"></path><path d="M442.68586667 623.4496l19.57333333 78.41066667-16.224 11.28533333z" fill="#F6851B" p-id="1715"></path><path d="M556.96426667 583.90613333l21.8624 39.50933334-23.3472 78.4576z" fill="#E4751F" p-id="1716"></path><path d="M571.71413333 713.1712l-16.23466666-11.29813333 23.3472-78.4576z" fill="#F6851B" p-id="1717"></path><path d="M464.1536 583.94666667l92.81066667-0.04053334-1.4848 117.96693334zM555.47733333 701.87306667l-93.21813333-0.0128 1.8944-117.9136z" fill="#F6851B" p-id="1718"></path><path d="M443.88906667 863.32586667l-6.09493334-31.3664-1.09866666-41.376zM581.1712 790.66453333l-0.1984 41.40373334-6.32106667 31.3792z" fill="#C0AD9E" p-id="1719"></path><path d="M436.69546667 790.58346667l8.18773333-12.04053334-0.99413333 84.78293334zM443.88906667 863.32586667l0.99413333-84.78293334 127.66506667 0.064z" fill="#C0AD9E" p-id="1720"></path><path d="M572.54826667 778.60693333l2.10346666 84.84053334-130.76266666-0.1216zM574.65173333 863.44533333l-2.10346666-84.8384 8.62293333 12.0576z" fill="#C0AD9E" p-id="1721"></path><path d="M444.88533333 778.54293333l-8.18986666 12.04053334 9.33973333-77.43573334zM571.71413333 713.1712l9.45706667 77.49333333-8.62293333-12.0576zM460.928 708.90026667l1.3312-7.04 93.22026667 0.0128z" fill="#161616" p-id="1722"></path><path d="M446.03733333 713.14773333l16.22186667-11.28746666-1.32906667 7.04z" fill="#161616" p-id="1723"></path><path d="M555.47733333 701.87306667l0.46506667 7.04426666-95.01226667-0.01706666zM555.9424 708.91733333l-0.46293333-7.04426666 16.23466666 11.29813333zM446.03733333 713.14773333l4.50133334 7.4624-5.65333334 57.9328z" fill="#161616" p-id="1724"></path><path d="M460.928 708.90026667l-10.38933333 11.70986666-4.50133334-7.4624zM572.54826667 778.60693333l-6.21013334-57.9712 5.376-7.46666666z" fill="#161616" p-id="1725"></path><path d="M571.71413333 713.1712l-5.376 7.46453333-10.39573333-11.7184zM572.54826667 778.60693333l-127.66506667-0.064 5.65333333-57.9328zM450.53866667 720.61013333l115.79733333 0.0256 6.21226667 57.9712zM450.53866667 720.61013333l10.38933333-11.70986666 95.0144 0.01706666z" fill="#161616" p-id="1726"></path><path d="M555.9424 708.91733333l10.39573333 11.7184-115.79946666-0.0256z" fill="#161616" p-id="1727"></path></svg>
          MetaMask</p>
          <p><a href="https://shimo.im/docs/QvjthXWWGXHj8dq3/read" class="compass" target="_blank" >如何玩?</a></p>
      </div>
    </template>
    <div v-if="show" class="clock-class">
      <analog-clock />
      <div class="tip-word">
        <h2>距Happy Store上线({{ beginTime }})</h2>
        <p>还剩</p>
        <h2>{{ left }}</h2>
      </div>
    </div>
    <four-lists ref="list" v-show="myAddress && !loadingData" @refresh-balance="refreshBalance"></four-lists>
    <!-- 全局通知类组件 -->
    <loading-queue></loading-queue>
    <notifications position="top center" group="notify" class="hst-notify"/>
    <Loading 
      :active.sync="confirming"
      :can-cancel="false" 
      :is-full-page="true"
      color="#a55aff"
      background-color="#4b4b4b"
      loader="bars"
      class="hst-loading"
    >
      <template v-slot:after>
        <div v-if="trx">区块正在确认中: {{ trx }}</div>
        <div v-else>连接到区块链,数据加载中...</div>
      </template>
    </Loading>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Web3 from 'web3'
import { loadWeb3 } from './util';
import Wallet from './components/Wallet.vue';
import FourLists from './components/FourLists.vue';
import LoadingQueue from './components/loadingQueue.vue';
// Inport component
import Loading from 'vue-loading-overlay'
// Inport stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { AnalogClock } from 'vue-analog-clock'

function parseTime(seconds) {
  let res = '';
  let day = Math.floor(seconds / (3600 * 24));
  if(day >= 0) res += (day < 10 ? '0' + day  : day) + '天';
  let hours = Math.floor((seconds % (3600 * 24) / 3600));
  if(hours >= 0) res += (hours < 10 ? '0' + hours : hours) + '小时';
  let min = Math.floor(((seconds % (3600 * 24)) % 3600) / 60);
  if(min >= 0) res += (min < 10 ? '0' + min : min) + '分钟';
  let sec = ((seconds % (3600 * 24)) % 3600) % 60;
  if(sec >= 0) res += (sec < 10 ? '0' + sec : sec) + '秒';
  return res;
}

export default {
  name: 'app',
  data() {
    return {
      loading: true,
      linkWallet: true,
      // show 表示是否展示时钟
      show: true,
      left: ''
    }
  },
  components: {
    Wallet,
    Loading,
    FourLists,
    LoadingQueue,
    AnalogClock,
  },
  computed: {
    ...mapState({
      usdtContract: state => state.usdtContract,
      hstContract: state => state.hstContract,
      myAddress: state => state.myAddress,
      usdtAddress: state => state.usdtAddress,
      hstAddress: state => state.hstAddress,
      confirming: state => state.confirming,
      trx: state => state.trx,
      loadingData: state => state.loadingData,
    }),
    beginTime() {
      const d = new Date(2020, 1, 14, 10, 0, 0, 0)
      return d.toLocaleString();
    }
  },
  methods: {
    async linkMetaMask() {
      // web3 加载
      this.$store.commit('setConfirming', true);
      await loadWeb3();
      const web3 = window.web3;
      const accounts = await web3.eth.getAccounts();
      this.$store.commit('setMyAddress', accounts[0]);
      // 账号切换时刷新
      const timer = setInterval(async function() {
        const accountNow = await web3.eth.getAccounts();
        if(accountNow[0] !== accounts[0]) {
          clearInterval(timer);
          window.location.reload();
        }
      }, 5000, accounts, web3);
      await this.$store.dispatch('createUsdtContract');
      await this.$store.dispatch('createHstContract');
      this.linkWallet = false;
      // 根据地址反查你的注册名字 若注册名字为空则显示注册
      let registerName = await this.hstContract.methods.refs(this.myAddress).call();
      registerName = Web3.utils.hexToUtf8(registerName);
      this.$store.commit('setRegisterName', registerName);
      // 获取邀请人名字(直接转byte32 就可以了 不用反查邀请人的地址)
      await this.$store.commit('setReferNameByte32');
      // 获取总的质押与分红情况
      this.$refs.wallet.refreshBalance();

      this.$refs.list.refershStakeList();
      this.$refs.list.getLock1AndTime();
      this.$refs.list.getLock2AndTime();

      const res = await this.usdtContract.methods.allowed(this.myAddress, this.hstAddress).call();
      let firstBuy = true;
      if (res > 100000) firstBuy = false;
      this.$store.commit('setFirstBuy', firstBuy);
    },

    refreshBalance() {
      this.$refs.wallet.refreshBalance();
    }
  },
  mounted() {
    const loading = document.getElementById('loading');
    const parent = loading.parentElement;
    parent.removeChild(loading);
    this.loading = false;
    const begin = new Date(2020, 1, 14, 10, 0, 0, 0);
    const timer = setInterval(() => {
      let now = new Date;
      // 2020年2月14日10点
      if(now > begin) {
        this.show = false;
        this.left = '00天00小时00分钟00秒';
        clearInterval(timer);
      }
      if(now < begin) {
        this.show = true;
        const leftSeconds = Math.floor((begin.getTime() - now.getTime()) / 1000);
        if(leftSeconds <=0 ) {
          this.left = '00天00小时00分钟00秒';
          return;
        };
        this.left = parseTime(leftSeconds);
      }
    }, 1000);
  }
}
</script>

<style lang="less">
.clock-class {
  margin-top: 100px;
  canvas {
    margin-bottom: 24px;
  }
  text-align: center;
  .tip-word {
    h2 {
      margin: 10px 0;
      font-size: 120%;
    }
  }
}
.logo {
  position: fixed;
  width: 96px;
  left: 48px;
}
html body {
  width: 100%;
}
@import url(./style/reset.css);
@media (max-width: 600px){
  .clock-class {
    margin-top: 0;
  }
  .logo {
    position: relative;
    left: 0;
  }
  .wallet {
    padding-top: 30%!important;
  }
  #app {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .my-token {
    margin: 0 !important;
    right: 0 !important;
  }
  .hst-loading .vld-icon {
    div {
      white-space: normal;
      word-wrap: break-word;
      word-break: break-all;
      max-width: 80%;
      text-align: center;
    }
  }
}
span {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  .hst-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(246, 248, 249);
    z-index: -10;
  }
  .wallet {
    padding-top: 130%;
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
      font-size: 1.2rem;
      line-height: 1;
      font-weight: 500;
      color: rgb(35, 21, 54);
      letter-spacing: 0px;
    }
    p {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 160px;
      font-size: 1rem;
      font-weight: 600;
      box-shadow: none;
      cursor: pointer;
      color: rgb(112, 131, 144);
      background-color: white;
      padding: 13px 26px;
      border-width: 1px;
      border-style: solid;
      border-image: initial;
      border-radius: 4px;
      outline: none;
      height: 24px;
      border-color: rgb(194, 194, 194);
      .icon {
        margin-right: 12px;
      }
      .compass {
        // font-size: 24px;
        cursor: pointer;
        color: #708390;
        font-size: 1rem;
        font-weight: 600;
        text-decoration: none;
      }
    }
  }
}
.hst-loading .vld-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  div {
    margin-left: 0;
  }
}
button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  font-weight: 500;
  user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}

input {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  font-size: 1.1rem;
  outline: none;
  padding: 0 15px;
  display: inline-block;
  box-sizing: border-box;
  width: 80%;
}
.modal-info {
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    text-align: center;
    display: inline-block;
    font-size: 1.2rem;
    padding: 10px;
    padding-bottom: 24px;
  }
}

.hst-notify {
  margin-top: 18px;
  .notification-content {
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
